module.exports = __webpack_public_path__ + "img/Telegram.fc6944da.svg";